import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"container-locations",attrs:{"fluid":""}},[_c(VContainer,{staticClass:"container-locations"},[_c('locations-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }